import { Result } from "@gp/models";

export type EventNotificationPayload = {
	eventId: string;
	eventName: string;
	matchStatusAbrv:
		| MatchStatusAbrv.START
		| MatchStatusAbrv.HT
		| MatchStatusAbrv.END;
	matchStatusId: string;
};

export type Payload =
	| EventNotificationPayload
	| EventEndNotificationPayload
	| BetSlipNotificationPayload;

export type EventEndNotificationPayload = EventNotificationPayload & {
	startTime: string;
	result: string;
	sportAbrv: string;
	sportCategoryAbrv: string;
	sportCategoryId: string;
	sportCategoryName: string;
	sportId: string;
	sportName: string;
	tournamentAbrv: string;
	tournamentId: string;
	tournamentName: string;
};

export type BetSlipNotificationPayload = {
	betSlipId: string;
	userId: string;
	agencyId: string;
	betSlipNumber: string;
	betSlipStatusAbrv: string;
	betStatusAbrv: string;
};

export enum MatchStatusAbrv {
	START = "started",
	HT = "halftime",
	END = "ended",
}

export enum NotificationEventType {
	BET_SLIP = "BetSlip",
	EVENT = "Event",
}

export type EndNotificationPayloadWithFT = Omit<
	EventEndNotificationPayload,
	"result"
> & {
	result: Result & {
		fullTimeScore: {
			away?: number | undefined;
			home?: number | undefined;
		};
	};
};
